var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAutomationsColored = function SvgAutomationsColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.047,
    height: 10.951,
    x: 5.183,
    y: 6.287,
    stroke: "#000",
    rx: 2.259
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M8.974 10.072v2.285M13.35 10.072v2.285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 10.701c0-.624.506-1.13 1.13-1.13h1.06v4.381H4.13A1.13 1.13 0 0 1 3 12.823zM17.234 9.572h1.061c.624 0 1.13.505 1.13 1.13v2.121a1.13 1.13 0 0 1-1.13 1.13h-1.06z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M11.162 3.5v2.285"
  })));
};
export default SvgAutomationsColored;